import { createContext, useEffect, useState, useCallback } from "react"
import { auth, db } from "../config/firebase"
import {
    createUserWithEmailAndPassword,
    onAuthStateChanged,
    signInWithEmailAndPassword,
    signOut,
  } from "firebase/auth";
import { getDoc,collection, getDocs, query, where, updateDoc, doc } from 'firebase/firestore';

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null)
    const [userProfile, setUserProfile] = useState(null)
    const [loading, setLoading] = useState(true)
    const [profileLoading, setProfileLoading] = useState(false)

    const createUser = (email, password) => {
        setLoading(true);
        return createUserWithEmailAndPassword(auth, email, password);
      };

    const loginUser = (email, password) => {
        setLoading(true);
        return signInWithEmailAndPassword(auth, email, password)
    }

    const logOut = () => {
        setLoading(true);
        setUserProfile(null);
        return signOut(auth);
    }

    // Rewritten: Use direct document lookup by UID, matching security rules.
    

    const loadUserProfile = useCallback(async (uid) => {
        if (!uid) return;

        try {
            setProfileLoading(true);
            // Direct document get by UID (users can only read their own doc per rules)
            const userDocRef = doc(db, "user", uid);
            const userSnap = await getDoc(userDocRef);

            if (!userSnap.exists()) {
                console.warn("No profile found for user");
                setUserProfile(null);
                return;
            }

            setUserProfile(userSnap.data());
        } catch (error) {
            console.error("Error loading profile:", error);
            setUserProfile(null);
        } finally {
            setProfileLoading(false);
        }
    }, []);

    const saveUserProfile = useCallback(async (userData) => {
        if (!user?.uid) return;
        
        try {
            const updatedData = {
                name: userData.name,
                bio: userData.bio,
                picurl: userData.picurl,
            };

            const userDocRef = doc(db, "user", user.uid);
            await updateDoc(userDocRef, updatedData);
            setUserProfile(prev => ({ ...prev, ...updatedData }));
            return true;
        } catch (error) {
            console.error("Error saving profile:", error);
            throw error;
        }
    }, [user?.uid]);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
          setUser(currentUser);
          setLoading(false);
          
          // Load user profile when user changes
          if (currentUser) {
            loadUserProfile(currentUser.uid);
          } else {
            setUserProfile(null);
          }
        });
    
        return () => {
          unsubscribe();
        };
      }, [loadUserProfile]);

      const authValue = {
        createUser,
        user,
        userProfile,
        loginUser,
        logOut,
        loading,
        profileLoading,
        saveUserProfile,
        loadUserProfile,
      };

    return <AuthContext.Provider value={authValue}>{children}</AuthContext.Provider>;
}

export default AuthProvider;
